import { render, staticRenderFns } from "./ClipboardCopyComponent.vue?vue&type=template&id=280fc123"
import script from "./ClipboardCopyComponent.vue?vue&type=script&lang=ts"
export * from "./ClipboardCopyComponent.vue?vue&type=script&lang=ts"
import style0 from "./ClipboardCopyComponent.vue?vue&type=style&index=0&id=280fc123&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports